import image1 from '@/assets/images/news/detail/20200517/1.jpg';
import image2 from '@/assets/images/news/detail/20200517/2.jpg';
import image3 from '@/assets/images/news/detail/20200517/3.jpg';

export default {
  id: '20200517', //  模块 id
  title: '母亲节活动“用叮咚er的方式给妈妈做一道菜” 评选结果新鲜出炉', // 标题
  content: [
    // {
    //   type: 0, // 数据类型 0-普通文本 1-图片
    //   text: '2020年4月21日，这个必将载入叮咚史册的日子：北京我们来了！', // 文本内容
    //   isIndent: false, // 是否首行缩进 true-首行缩进 false-不缩进
    // },
    // {
    //   type: 1,
    //   title: '图片下方标题', // 图片下方标题
    //   src: [
    //     'kkk' // 图片地址
    //   ],
    // },

    {
      type: 0,
      text:
        '让我们看看有哪些暖心的小伙伴，用叮咚er的方式，在今年母亲节给妈妈留下了一份特别的回忆吧。',
      isIndent: false,
    },
    {
      type: 0,
      text: '暖心陪伴之最佳合影——最家常的馄饨，最简单的幸福',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '@人力资源部-庞绚 母亲节给妈妈包了手工大馄饨，浓浓的生活气息，厚厚的爱！',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: 0,
      text: '暖心陪伴之最佳文案——母亲的唠叨也是疼爱你的方式',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '@用户运营中心-凌瑶 我一直是妈妈嘴里不会干活的人，每次干活总是“吐槽”我：地板永远拖不干净，做饭太慢，你还是去看会电视吧！其实妈妈是为了让我有更多时间休息。今天母亲节，让我真正为妈妈下一回厨房，来自叮咚的韭菜花，搭配新鲜的海螺味道超级棒。希望借此机会，向妈妈证明在外独立的自己不需要他们担心，我会努力生活得更好！',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image2, image3],
    },
    {
      type: 0,
      text:
        '除了以上优选的暖心陪伴奖获得者之外，还有不少小伙伴也与我们分享了他们给妈妈下厨、陪妈妈用餐的温馨瞬间，这些小伙伴也将获得叮咚MC文化送出50元叮咚买菜优惠券，请留意企业微信信息哦~感所有小伙伴的积极参与~',
      isIndent: false,
    },
  ],
};
